module.exports = __webpack_public_path__ + "static/media/loading.0adb133c.gif";